<template>
  <v-app-bar
    class="header-desktop-pages"
    :class="{
      'header-desktop-pages-home': this.$route.path === '/',
      secondary: this.$route.path !== '/',
    }"
    flat
    color="transparent"
    :height="this.$route.path === '/' ? '140px' : '90px'"
    :absolute="this.$route.path === '/'"
  >
    <v-container class="py-0">
      <v-sheet
        width="100%"
        height="100%"
        color="transparent"
        class="d-flex justify-space-between align-center"
      >
        <router-link to="/">
          <img
            v-if="informations.img"
            class="d-block"
            :src="files + informations.img"
            :alt="informations.name"
            height="42px"
          />
        </router-link>

        <div class="d-flex align-center">
          <div>
            <div
              v-for="({ text, to, dropdown }, keyMenu) in menu"
              :key="keyMenu"
              class="d-inline-flex"
            >
              <v-btn
                v-if="!dropdown"
                :to="to"
                class="
                  accent--text
                  text-h6
                  font-weight-regular
                  header-desktop-nav-btn
                "
                tile
                text
              >
                {{ text }}
              </v-btn>

              <v-menu v-else offset-y tile>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="
                      accent--text
                      text-h6
                      font-weight-regular
                      header-desktop-nav-btn
                    "
                    v-bind="attrs"
                    v-on="on"
                    :to="to"
                    tile
                    text
                  >
                    {{ text }}

                    <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
                  </v-btn>
                </template>

                <v-list tile>
                  <v-list-item
                    v-for="(item, keyDropdown) in dropdown"
                    :key="keyDropdown"
                    :to="item.to"
                  >
                    <v-list-item-title class="grey--text text--darken-3">
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>

          <div class="ml-4">
            <template v-for="({ text, link, icon }, keySocial) in social">
              <v-btn
                v-if="link"
                :key="keySocial"
                :href="link"
                :title="text"
                target="_blank"
                class="accent--text header-desktop-nav-btn-social"
                height="30"
                width="30"
                tile
                icon
              >
                <v-icon size="16"> {{ icon }} </v-icon>
              </v-btn>
            </template>
          </div>
        </div>
      </v-sheet>
    </v-container>
  </v-app-bar>
</template>

<script>
import { getTelLinkFromPhone } from "../../../utils/getTelLinkFromPhone";
import { getSocial } from "../../../utils/getSocial";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
  methods: {
    getTelLinkFromPhone,
  },
};
</script>

<style lang="scss" scoped>
.header-desktop-pages {
  &-home {
    background: rgb(0, 0, 0);
    background: -moz-linear-gradient(
      0deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(10, 10, 10, 1) 100%
    );
    background: -webkit-linear-gradient(
      0deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(10, 10, 10, 1) 100%
    );
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(10, 10, 10, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#0a0a0a",GradientType=1);
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 99;
  }

  .header-desktop-nav-btn {
    letter-spacing: 0;
    margin-left: 2px;
    transition: all 0.1s linear;

    &:before {
      opacity: 0;
    }

    &:after {
      background-color: rgba(255, 255, 255, 0.4);
      content: "";
      height: 20px;
      right: -2px;
      margin-top: -10px;
      position: absolute;
      top: 50%;
      width: 2px;
    }
  }
}
</style>
